export namespace S25Bool {
    export function toBool(bool: any): boolean {
        //convert falsy, even "false", "0", to false, truthy to true
        return !(
            bool == "F" ||
            bool === "false" ||
            bool === "0" ||
            bool === 0 ||
            bool === false ||
            bool === "" ||
            bool === undefined ||
            bool === null
        );
    }

    export function isBool(bool: any): bool is boolean {
        return bool === true || bool === false;
    }
    export function isTrue(str: any): boolean {
        return !!parseBoolean(str);
    }

    // bugs.collegenet.com/jira/browse/SPRING-653
    export function parseBoolean(str: any): any {
        if (typeof str !== "string" && typeof str !== "number") {
            return str;
        }

        const lStr: string = (str + "").toLowerCase();
        // ANG-7887: "yes" / "no" are toggle rule words. Without this, isTrue("No") is true
        // (leftover non-empty string) and `in No` cannot mean off.
        return lStr === "true" || lStr === "t" || lStr === "y" || str === "1" || lStr === "yes"
            ? true
            : lStr === "false" || lStr === "f" || lStr === "n" || lStr === "0" || lStr === "no"
              ? false
              : // non-boolean - return as is
                str;
    }

    export function toChar(value: boolean): "T" | "F" {
        return value ? "T" : "F";
    }

    export function isTruthy(obj: any): boolean {
        return !!obj;
    }

    export function undefinedif(obj: any, targetValue: any): any {
        return obj === targetValue ? undefined : obj;
    }
}
